import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

export async function fetchArchivedProjects({ limit = 500, offset = 0 } = {}) {
  const { data } = await axios.get(`${getApiBase()}/admin/archived-projects`, {
    headers: authHeaders(),
    params: { limit, offset },
  });
  return Array.isArray(data) ? data : [];
}

export async function restoreArchivedProject(archiveId) {
  const { data } = await axios.post(
    `${getApiBase()}/admin/archived-projects/${archiveId}/restore`,
    {},
    { headers: authHeaders() }
  );
  return data;
}

export async function permanentlyDeleteArchivedProjects(ids) {
  const { data } = await axios.post(
    `${getApiBase()}/admin/archived-projects/permanent-delete`,
    { ids },
    { headers: authHeaders() }
  );
  return data;
}

/** Archive projects to pb_archive_db and remove them from the live board (admin only). */
export async function archiveDeleteProjects(ids) {
  const { data } = await axios.post(
    `${getApiBase()}/projects/archive-delete`,
    { ids },
    { headers: authHeaders() }
  );
  return data;
}
